import React from 'react';
import { useSelector } from 'react-redux';
import { noInfoAnnouncements } from 'constants';
import MDTypography from 'components/MDTypography';
import { useRenderNoInfo } from 'utils/commonUtils';
import { cardListColors } from '../../DashboardUtils';
import { ListItemWrap, StatusDot } from '../dashboardStyled';

const DashboardAnnouncements = () => {
  const announcementNotificationData = useSelector(
    (state) => state.announcementNotificationData,
  );

  const noInfoComponent = useRenderNoInfo(
    announcementNotificationData?.items,
    noInfoAnnouncements,
  );

  return (
    <>
      {noInfoComponent}
      {announcementNotificationData?.items?.map((item, index) => {
        const { msg } = item;
        const dotColor = cardListColors[index % cardListColors.length];
        return (
          <ListItemWrap key={index}>
            <StatusDot bgcolor={dotColor} data-testid="status-dot" />
            <MDTypography variant="button" fontWeight="bold" color="text">
              {msg}
            </MDTypography>
          </ListItemWrap>
        );
      })}
    </>
  );
};

export default DashboardAnnouncements;
